import { Chip } from "@dropbox/dig-components/chip";
import { Typeahead } from "@dropbox/dig-components/typeahead";
import { Text } from "@dropbox/dig-components/typography";
import React from "react";
import styles from "./FilterRow.module.css";

export type FilterRowProps = {
  title: string;
  icon: React.ReactNode;
  onClick: () => void;
  countLabel?: string;
  loading?: boolean;
};

export const FilterRow = ({
  title,
  icon,
  countLabel,
  onClick,
  loading,
}: FilterRowProps) => {
  return (
    <Typeahead.Row
      className={styles.filterRow}
      withTitle={
        <Text variant="label" color="subtle" className={styles.filterTitle}>
          {title}
        </Text>
      }
      withLeftAccessory={icon}
      withRightAccessory={
        loading ? (
          <LoadingIndicator />
        ) : countLabel ? (
          <Text variant="label" color="subtle" size="small">
            {countLabel}
          </Text>
        ) : undefined
      }
      onClick={onClick}
    ></Typeahead.Row>
  );
};

const LoadingIndicator = () => {
  return (
    <Chip
      variant="transparent"
      isSelected={false}
      selectedStyle="stroke"
      size="small"
      type="button"
      disabled={true}
    >
      <Chip.Content className={styles.loadingChip}>
        <span className={styles.loadingIndicator} />
      </Chip.Content>
    </Chip>
  );
};
